import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Typography,
} from '@material-ui/core';

import EventStats from '../EventStats';
import EventStateLabel from '../EventStateLabel';
import EventStatus from '../EventStatus';
import {
  getColorForItem,
  getIconForItem,
} from '../../../utils/iconHelper';
import styles from './styles';

class EventHeaderDetails extends React.Component {
  render() {
    const {
      classes,
      event,
      showStatus,
      statuses,
    } = this.props;

    const statusColor = getColorForItem(statuses, event.currentEventStatus.status.id);
    const statusIcon = getIconForItem(statuses, event.currentEventStatus.status.id);

    return (
      <div>
        <div className={classes.eventNameContainer}>
          <EventStateLabel archived={event.archived} completed={!!event.completeDate} />
          <h3 className={classes.eventName}>{event.name} <Typography variant="caption" className={classes.eventIdField}>#{event.id}</Typography></h3>
        </div>
        <div className={classes.statusContainer}>
          {
            showStatus
              && event.currentEventStatus
              && [(
                <EventStatus
                  eventStatus={event.currentEventStatus}
                  color={statusColor}
                  icon={statusIcon}
                  mini
                  key={`event-${event.id}-status-${event.currentEventStatus.id}-badge`}
                />
              ), (
                <span className={classes.statusName} key={`event-${event.id}-status-${event.currentEventStatus.id}-name`}>
                  {event.currentEventStatus.status.name}
                </span>
              )]
          }
          <EventStats event={event} />
        </div>
      </div>
    );
  }
}

EventHeaderDetails.propTypes = {
  classes: PropTypes.object,
  event: PropTypes.object,
  showStatus: PropTypes.bool,
  statuses: PropTypes.array,
};

EventHeaderDetails.defaultProps = {
  classes: {},
  event: {},
  showStatus: false,
  statuses: [],
};

export default (withStyles(styles, { withTheme: true })(EventHeaderDetails));
